module.exports = __webpack_public_path__ + "img/medal.468f27e2.svg";